var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((7),function(index){return _c('div',{directives:[{name:"visible",rawName:"v-visible",value:(index <= _vm.maxValue),expression:"index <= maxValue"}],class:index < _vm.value.min || index > _vm.value.max ? 'inactive' : 'active'},[_vm._v(" "+_vm._s(index)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }